module.exports = __webpack_public_path__ + "img/close-source.3d2fa7b4.svg";